<script setup lang="ts">
import type { CmsElementZebraCmsExpandableText } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementZebraCmsExpandableText;
}>();
const useHeight = ref(900);
const { headlineText, buttonRight, buttonLeft, mainText, backgroundMobile, backgroundDesktop, height, headlineType } = props.content?.config

// Computed property for dynamic component
const dynamicHeadline = computed(() => {
  const tag = headlineType?.value || 'h3';
  const validTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
  return validTags.includes(tag) ? tag : 'h3';
});

// Render function for dynamic headline
const renderHeadline = () => {
  const tag = headlineType?.value || 'h3';
  const validTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
  const finalTag = validTags.includes(tag) ? tag : 'h3';
  
  return h(finalTag, {
    class: 'text-[30px] md:text-[40px] text-white mb-5 font-bold uppercase'
  }, headlineText.value);
};

onMounted(() => {
  if(!height || height.value === '') {

  } else {
    useHeight.value = height.value;
  }
})

</script>
<template>
  <section class="relative">
    <figure v-if="useHeight" :style="'height:'+useHeight+'px'">
      <template v-if="backgroundDesktop.value && backgroundMobile.value">
        <NuxtImg format="webp" loading="lazy" v-if="backgroundDesktop.value" :src="backgroundDesktop.value.url" class="img-cover hidden md:block" alt="" width="1680" densities="x1" />
        <NuxtImg format="webp" loading="lazy" v-if="backgroundMobile.value" :src="backgroundMobile.value.url" class="img-cover md:hidden" alt="" width="768" densities="x1"/>
      </template>
      <template v-else-if="backgroundDesktop.value">
        <NuxtImg format="webp" loading="lazy" :src="backgroundDesktop.value.url" class="img-cover" alt="" width="1680" densities="x1" />
      </template>
      <template v-else-if="backgroundMobile.value">
        <NuxtImg format="webp" loading="lazy" :src="backgroundMobile.value.url" class="img-cover" alt=""  width="768" densities="x1"/>
      </template>
    </figure>
    <div class="w-full absolute bottom-[120px] top-[60%] -translate-y-2/4 ">
      <div class="container">
        <div class="overlayTxtSize text-white">
          <component :is="renderHeadline" />
          <div class="mb-8" v-html="mainText.value"></div>
          <div class="flex flex-wrap gap-5">
            <SharedButton v-if="buttonLeft" btnType="secondary" :button="buttonLeft.value"></SharedButton>
            <SharedButton v-if="buttonRight" btnType="outline" :button="buttonRight.value"></SharedButton>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
